const DesignedButton = ({
  color,
  text,
  onClickFunction,
}: {
  color: string;
  text: string;
  onClickFunction: any;
}) => {
  return (
    <div>
      <button
        onClick={onClickFunction}
        className={`mt-3 font-bold inline-block w-auto text-center min-w-[200px] px-6 py-4 text-white transition-all rounded-md shadow-xl sm:w-auto bg-gradient-to-r from-${color}-600 to-${color}-500 hover:bg-gradient-to-b dark:shadow-${color}-900 shadow-${color}-200 hover:shadow-2xl hover:shadow-${color}-400 hover:-tranneutral-y-px`}
      >
        {text}
      </button>
    </div>
  );
};

export default DesignedButton;
